import { normalizeUTCString } from "../../../utils";
export var getStatusAge = function getStatusAge(date) {
  if (!date) return null;
  var diffMs = Date.now() - new Date(normalizeUTCString(date)).getTime();
  var days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (Number.isNaN(days) || days < 0) return "Upcoming";
  if (days >= 14) return "14+ days";
  return "".concat(days, " day").concat(days === 1 ? "" : "s");
};